(function () {
  'use strict';

  function initReveal() {
    var targets = document.querySelectorAll('[data-rebel-reveal], [data-rebel-reveal-group]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  function initStickyCta() {
    var bar = document.querySelector('[data-rebel-sticky-cta]');
    var hero = document.querySelector('.rebel-hero');
    if (!bar || !hero) return;

    var heroObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    heroObserver.observe(hero);
  }

  function initFaqAccordion() {
    var items = document.querySelectorAll('.rebel-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      if (item.dataset.rebelFaqBound) return;
      item.dataset.rebelFaqBound = 'true';

      var summary = item.querySelector('summary');
      var panel = item.querySelector('p');
      if (!summary || !panel) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.hasAttribute('open');

        if (isOpen) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.maxHeight = '0px';
          });
          panel.addEventListener('transitionend', function handler() {
            item.removeAttribute('open');
            panel.style.maxHeight = '';
            panel.removeEventListener('transitionend', handler);
          });
        } else {
          item.setAttribute('open', '');
          panel.style.maxHeight = '0px';
          requestAnimationFrame(function () {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          });
          panel.addEventListener('transitionend', function handler() {
            panel.style.maxHeight = '';
            panel.removeEventListener('transitionend', handler);
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initStickyCta();
      initFaqAccordion();
    });
  } else {
    initReveal();
    initStickyCta();
    initFaqAccordion();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initStickyCta();
    initFaqAccordion();
  });
})();
